import React, { useContext, useEffect } from "react";
import {
  BrowserRouter,
  HashRouter,
  MemoryRouter,
  Route,
  Routes,
  useNavigate
} from "react-router-dom";

import { UserContext } from "./auth/contexts/user";
import LoginPage from "./auth/login-page/login-page";
import BillManagementPage from "./bill-management/bill-management-page";
import DemandResponsePage from "./demand-response/demand-response-page";
import MeterManagementPage from "./meter-management/meter-management-page";
import { MicrofrontendRoutes } from "./microfrontend-routes";
import NotFound from "./not-found/not-found";

function Redirect({ to }) {
  let navigate = useNavigate();
  useEffect(() => {
    navigate(to);
  });
  return null;
}

// eslint-disable-next-line react/prop-types
const PrivateComponent = ({ children }) => {
  const { user } = useContext(UserContext);

  console.log({ user });

  return user ? children : <Redirect to="/login" />;
};

/**
 *
 * @param {object} props
 * @param {boolean} props.isMicrofrontendsEnabled
 * @param {boolean} props.isLoginMicrofrontendEnabled
 * @returns {JSX.Element}
 */
const AppRoutes = ({
  isMicrofrontendsEnabled,
  isLoginMicrofrontendEnabled
}) => {
  const Router =
    typeof window === "undefined"
      ? MemoryRouter
      : isMicrofrontendsEnabled
      ? BrowserRouter
      : HashRouter;
  return (
    <Router
      {...(isMicrofrontendsEnabled ? { basename: process.env.PUBLIC_URL } : {})}
    >
      <Routes>
        <Route path="/" element={<Redirect to="/accounts" />} />
        <Route
          path="/bill-management"
          element={
            <PrivateComponent>
              <BillManagementPage />
            </PrivateComponent>
          }
        />
        <Route
          path="/demand-response"
          element={
            <PrivateComponent>
              <DemandResponsePage />
            </PrivateComponent>
          }
        />
        <Route
          path="/meter-management"
          element={
            <PrivateComponent>
              <MeterManagementPage />
            </PrivateComponent>
          }
        />
        {isMicrofrontendsEnabled && isLoginMicrofrontendEnabled ? null : (
          <Route path="/login" element={<LoginPage />} />
        )}
        <Route
          path="*"
          element={
            isMicrofrontendsEnabled ? <MicrofrontendRoutes /> : <NotFound />
          }
        />
      </Routes>
    </Router>
  );
};

AppRoutes.defaultProps = {
  isMicrofrontendsEnabled: process.env.REACT_APP_USE_MICROFRONTENDS === "true",
  isLoginMicrofrontendEnabled:
    process.env.REACT_APP_ENABLE_LOGIN_MICROFRONTEND === "true"
};

export default AppRoutes;
